module.exports = __webpack_public_path__ + "img/adModel6.dae7c68e.png";